import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import VoucherCompactList from "../components/VoucherCompactList";

const VoucherSplitView = () => <MasterDetailLayout list={<VoucherCompactList />} />;

export default VoucherSplitView;
